module.exports = __webpack_public_path__ + "img/onlylive-logo.2365717a.png";